// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NhhD","col":"styles_col__1zTyR"};